import PropTypes from 'prop-types';
import { createContext, useState } from 'react';

const defaultValue = { isMobile: false };

const SSRDeviceContext = createContext(defaultValue);

/**
 * Provides SSR device hint (mobile vs desktop) so the initial HTML matches the requesting device.
 * - Server: pass isMobile from User-Agent so we render the correct layout.
 * - Client: reads window.__SSR_DEVICE__ (injected by server) so hydration matches.
 */
function SSRDeviceProvider({ children, isMobile: isMobileProp = false }) {
    const [value] = useState(() => {
        /* eslint-disable no-underscore-dangle */
        if (typeof window !== 'undefined' && window.__SSR_DEVICE__ != null) {
            return { isMobile: !!window.__SSR_DEVICE__.isMobile };
        }
        /* eslint-enable no-underscore-dangle */
        return { isMobile: !!isMobileProp };
    });

    return <SSRDeviceContext.Provider value={value}>{children}</SSRDeviceContext.Provider>;
}

SSRDeviceProvider.propTypes = {
    children: PropTypes.node,
    /** Set by server from User-Agent; ignored on client in favor of window.__SSR_DEVICE__ */
    isMobile: PropTypes.bool
};

export { SSRDeviceContext, SSRDeviceProvider };
